import type { SVGProps } from 'react';
const SvgSystemUpdateAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#system_update_alt_svg__a)">
      <path
        fill="currentColor"
        d="m12 16.5 4-4h-3v-9h-2v9H8l4 4Zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2Z"
      />
    </g>
    <defs>
      <clipPath id="system_update_alt_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSystemUpdateAlt;
